import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useEffect, useState } from 'react';
import CustomerAPI from '../services/customer.api.service';
import useAlert from './Alert/useAlert';
import { CustomerTableRow } from './CustomerTableRow';
import { StyledHeaderCell } from './StyledHeaderCell';

export const CustomersTable = ({context, role, onCustomerSelect}) => {
    const {showErrorAlert} = useAlert();
    const [state, setState] = useState({
        customers: [],
        customer: '',
        loading: false,
    });

    useEffect(() => {onContextChange()}, [context, role])
    useEffect(() => {onCustomerSelect(state.customer)}, [state.customer])
    const changeState = (partialState) => setState(currentState => ({...currentState, ...partialState}));
    const startLoading = () => changeState({loading: true});
    const stopLoading = () => changeState({loading: false});

    const onContextChange = () => {
        startLoading();
        CustomerAPI
            .getCustomersByRole(context?.id, role)
            .then(customers => changeState({
                customers: customers.items,
                customer: customers.items[0] || null,
            }))
            .catch(err => showErrorAlert(err.response.data.message))
            .finally(() => stopLoading());
    };

    return <Table
        size="small"
        sx={{
            border: '1px solid grey',
            mb: 3,
        }}
    >
        <TableHead>
            <TableRow>
                <StyledHeaderCell>Company</StyledHeaderCell>
                <StyledHeaderCell>Country</StyledHeaderCell>
                <StyledHeaderCell>Email</StyledHeaderCell>
                <StyledHeaderCell>Phone</StyledHeaderCell>
                <StyledHeaderCell>Wallet</StyledHeaderCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {state.customers.map(customer =>
                <CustomerTableRow
                    key={customer.id}
                    customer={customer}
                    onCustomerSelect={customer => changeState({customer})}
                    selected={customer.id === state.customer?.id}
                />
            )}
        </TableBody>
    </Table>
}
